import { guideSteps } from "@/mocks/civicData";

export default function Guide() {
  return (
    <section
      id="guide"
      className="relative scroll-mt-24 bg-foreground-950 py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-end gap-8 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-medium text-accent-300">
              <span className="h-px w-8 bg-accent-400"></span>
              信息提供指南
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-background-50 md:text-4xl">
              一条有效线索，
              <br />
              是怎么说清楚的
            </h2>
          </div>
          <p className="text-base leading-8 text-background-100/80 lg:text-right">
            掌握以下六个步骤，你的反映会更清晰、更可信，也更便于相关部门及时跟进处理。
          </p>
        </div>

        <ol className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {guideSteps.map((s) => (
            <li
              key={s.step}
              className="group relative overflow-hidden rounded-2xl border border-background-100/10 bg-background-100/5 p-6 transition-colors hover:bg-background-100/10"
            >
              <span className="pointer-events-none absolute -right-2 -top-6 font-heading text-7xl font-black text-background-50/5">
                {s.step}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-xl text-foreground-950">
                <i className={s.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-background-100/80">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}